module.exports = __webpack_public_path__ + "m.no2.0e491ebe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/m.no2.jpg
// module id = URGJ
// module chunks = 0